import { render } from "./FacebookButton.vue?vue&type=template&id=b542e5f0"
const script = {}
script.render = render

export default script